// Verbose auth diagnostics ([auth] / [auth-debug]) are for local development.
// Production and staging bundles stay silent unless explicitly opted in, either
// at build time (VITE_XENTROS_ENABLE_AUTH_DEBUG=true) or for one browser during
// a support session (localStorage "xentros.auth.debug" = "true").
//
// Keep this file import-free and env access optional-chained: auth modules are
// also loaded by Node tests, where import.meta.env does not exist.

export const AUTH_DEBUG_STORAGE_KEY = "xentros.auth.debug";

export function isAuthDebugEnabled(): boolean {
  const env = import.meta.env as Record<string, unknown> | undefined;
  if (env?.DEV === true) return true;
  if (String(env?.VITE_XENTROS_ENABLE_AUTH_DEBUG ?? "").trim().toLowerCase() === "true") return true;
  try {
    return typeof window !== "undefined" && window.localStorage.getItem(AUTH_DEBUG_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function authDebugLog(label: string, details?: Record<string, unknown>) {
  if (!isAuthDebugEnabled()) return;
  if (details === undefined) {
    console.info(label);
    return;
  }
  console.info(label, details);
}

// Header names are useful for debugging; values (Authorization, cookies) never
// belong in a console.
export function describeHeadersForDebug(headers: Headers) {
  return Object.fromEntries(
    [...headers.entries()].map(([name, value]) => [
      name,
      /^(authorization|cookie|x-pos-tablet-credential)$/i.test(name) ? "[redacted]" : value,
    ]),
  );
}
